import React from "react";

function BS4_BasicTemplate() {
  return (
    <div>
      <h1>BS4_BasicTemplate Component</h1>
      <p>This is the BS4_BasicTemplate tutorial page content.</p>
    </div>
  );
}

export default BS4_BasicTemplate;
